import VueAdsense from './VueAdsense.vue'
export default VueAdsense



//////////////////
// WEBPACK FOOTER
// ./~/vue-adsense/main.js
// module id = 12
// module chunks = 0